<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <p class="title md-headline">SMS, Identity and document overage invoice</p>
      </div>
    </div>

    <form
      class="md-layout md-gutter mb-1"
      v-if="invoicingEnterprise"
      @submit.prevent="invoiceEnterprise">
      <div class="md-layout-item md-small-size-100">
        <p class="md-subheading composed-items">Invoicing enterprise the predicted
          value of
          <span>{{ invoicePredictedValue | toCurrency }} (</span>
          <span v-if="invoicesDocuments">
            {{ documentPrice | toCurrency }} for {{ documentCount }} documents
          </span>
          <span v-if="invoicesDocuments && invoicesSms" class="space-after">,</span>
          <span v-if="invoicesSms">{{ smsPrice | toCurrency }} for {{ smsCount }} SMS</span>
          <span v-if="invoicesIdentityRequests">
            {{ identityPrice | toCurrency }} for {{ identityCount }} identity requests
          </span>
          <span v-if="(invoicesDocuments || invoicesSms) && invoicesIdentityRequests"
            class="space-after">,</span>
          <span>).</span>
        </p>

        <p class="md-subheading">
          This value is predicted and may change if the client sends other documents or SMSes until
          we process this request.
        </p>
      </div>
    </form>

    <div class="md-layout" v-if="!invoicingEnterprise">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Last overage invoiced at</p>
        <span class="md-subheading" v-if="localEnterprise.owner.lastOverageInvoicedAt">
          {{ $moment(localEnterprise.owner.lastOverageInvoicedAt).format('DD/MM/YYYY HH:mm:ss') }}
        </span>
        <span class="md-subheading" v-if="!localEnterprise.owner.lastOverageInvoicedAt">
          Business had not been invoiced.
        </span>
      </div>
    </div>

    <div class="md-layout" v-if="missingConfiguration && !invoicingEnterprise">
      <div class="md-layout-item md-small-size-100 mb-1">
        <p class="md-subheading">Missing configuration:</p>
        <p class="md-subheading" v-if="missingConfiguration['documents']">
          Document quota negative, but overage price not set. Overage for documents will not be
          billed.
        </p>
        <p class="md-subheading" v-if="missingConfiguration['sms']">
          SMS quota negative, but overage price not set. Overage for SMS will not be billed.
        </p>
        <p class="md-subheading" v-if="missingConfiguration['identityRequests']">
          Identity Request quota negative, but overage price not set. Overage for identity
          Request will not be billed.
        </p>
      </div>
    </div>

    <div class="md-layout" v-if="invoiceReturn.id">
      <div class="md-layout-item md-small-size-100 md-size-50">
        <md-card class="invoice-return">
          <md-card-header>
            <p class="md-title">Business invoiced</p>
          </md-card-header>
          <md-card-content>
            <p>Business billed for:</p>
            <p>
              <span v-if="invoiceReturn.overageDocuments > 0">
                {{ invoiceReturn.totalDocuments() | toCurrency }}
                ({{ invoiceReturn.overageDocuments }} documents)
              </span>
              <span v-if="invoiceReturn.overageDocuments > 0 && invoiceReturn.overageSms > 0">
                <br />
              </span>
              <span v-if="invoiceReturn.overageSms > 0">
                {{ invoiceReturn.totalSms() | toCurrency }}
                ({{ invoiceReturn.overageSms }} SMS)
              </span>
              <span v-if="(invoiceReturn.overageSms > 0 && invoiceReturn.overageIdentity > 0) ||
                  (invoiceReturn.overageDocuments > 0 && invoiceReturn.overageIdentity > 0)">
                <br />
              </span>

              <span v-if="invoiceReturn.overageIdentity > 0">
                {{ invoiceReturn.totalIdentityRequests() | toCurrency }}
                ({{ invoiceReturn.overageIdentity }} identity requests)
              </span>
            </p>
            <p>Total: {{ invoiceReturn.total | toCurrency }}</p>

            <div class="md-layout">
              <div class="md-layout-item">
                <md-button class="md-raised md-primary" :href="invoiceReturn.url()" target="_blank">
                  Open Stripe invoice
                </md-button>
              </div>
              <div class="md-layout-item text-right">
                <md-button class="md-raised" @click="initInvoiceReturn">Close</md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-button class="md-raised" @click="invoicingEnterprise = true"
          v-if="canInvoiceEnterprise && !updatingOverage &&
                !invoicingEnterprise && !invoiceReturn.id">
          Invoice business
        </md-button>
      </div>
      <md-button class="md-raised" @click="invoicingEnterprise = false"
        v-if="invoicingEnterprise && !loaders.invoice">
        Cancel
      </md-button>
      <md-button class="md-raised md-primary" @click="invoiceEnterprise"
        v-if="invoicingEnterprise && !loaders.invoice">
        Send invoice
      </md-button>
      <md-button class="md-raised" v-if="loaders.invoice">
        Invoicing business...
      </md-button>
    </div>

    <snackbar-message-handler :message="snackbarMessage" @md-closed="snackbarMessage = ''">
    </snackbar-message-handler>
  </div>
</template>
<style lang="scss">
.md-app-content .md-card.invoice-return {
  margin: 16px 0;
}
.composed-items span {
  display: inline-block;
}
.space-after::after {
  content: ' ';
  display: block;
  width: 7px;
}
</style>
<script type="ts">
import camelcaseKeysDeep from 'camelcase-keys-deep';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import Enterprise from '@/datatypes/enterprise';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import EnterpriseInvoiceReturn from '@/datatypes/enterprise/invoice-return';

export default {
  components: {
    SnackbarMessageHandler,
  },
  name: 'enterprise-overage-invoice',
  props: ['enterprise'],
  methods: {
    invoiceEnterprise() {
      this.loaders.invoice = true;
      this.enterpriseService.invoiceEnterprise(this.enterprise.id).then((response) => {
        this.invoiceReturn = new EnterpriseInvoiceReturn(camelcaseKeysDeep(response.data));
        this.snackbarMessage = 'Business invoiced.';
        this.enterpriseService.getEnterprise(this.enterprise.id).then((enterpriseResponse) => {
          this.localEnterprise = new Enterprise(camelcaseKeysDeep(enterpriseResponse.data));
        });
      }).catch((error) => {
        this.snackbarMessage = error.response.data.message;
      }).finally(() => {
        this.invoicingEnterprise = false;
        this.loaders.invoice = false;
      });
    },
    initInvoiceReturn() {
      this.invoiceReturn = new EnterpriseInvoiceReturn({});
    },
  },
  computed: {
    canInvoiceEnterprise() {
      return this.invoicesDocuments || this.invoicesSms || this.invoicesIdentityRequests;
    },
    invoicesDocuments() {
      return this.enterprise.owner.stripeOveragePrice && (this.enterprise.quota < 0);
    },
    invoicesSms() {
      return this.enterprise.owner.stripeSmsOveragePrice && (this.enterprise.smsQuota < 0);
    },
    invoicesIdentityRequests() {
      return this.enterprise.owner.stripeIdentityOveragePrice
            && (this.enterprise.identityRequestQuota < 0);
    },

    documentPrice() {
      if (this.enterprise.quota > 0) return 0;

      return this.documentCount * this.enterprise.owner.stripeOveragePrice;
    },
    documentCount() {
      if (this.enterprise.quota > 0) return 0;

      return Math.abs(this.enterprise.quota);
    },
    smsPrice() {
      return this.smsCount * this.enterprise.owner.stripeSmsOveragePrice;
    },
    smsCount() {
      if (this.enterprise.smsQuota > 0) return 0;

      return Math.abs(this.enterprise.smsQuota);
    },
    identityPrice() {
      return this.identityCount * this.enterprise.owner.stripeIdentityOveragePrice;
    },
    identityCount() {
      if (this.enterprise.identityRequestQuota > 0) return 0;
      return Math.abs(this.enterprise.identityRequestQuota);
    },
    invoicePredictedValue() {
      return this.documentPrice + this.smsPrice + this.identityPrice;
    },
    missingConfiguration() {
      const documents = !this.enterprise.owner.stripeOveragePrice && (this.enterprise.quota < 0);
      const sms = !this.enterprise.owner.stripeSmsOveragePrice && (this.enterprise.smsQuota < 0);
      const identityRequests = !this.enterprise.owner.stripeIdentityOveragePrice
                                  && (this.enterprise.identityRequestQuota < 0);

      if (!documents && !sms && !identityRequests) {
        return undefined;
      }

      return {
        documents,
        sms,
        identityRequests,
      };
    },
    localEnterprise: {
      get() {
        return this.enterprise;
      },
      set(value) {
        this.$emit('enterpriseChange', value);
      },
    },
  },
  data: () => ({
    updatingOverage: false,
    creatingPrice: false,
    invoicingEnterprise: false,
    enterpriseService: new EnterpriseService(),
    overage: {
      newPrice: '',
      prices: [],
    },
    loaders: {
      invoice: false,
    },
    snackbarMessage: '',
    invoiceReturn: new EnterpriseInvoiceReturn({}),
  }),
};
</script>
